import React from "react";
import { Col, Container, Row } from "reactstrap";
import { DocumentRetention } from "./DocumentRetention";

export function DocumentManagementModule() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
            <h3 style={{ marginBottom: 30, color:"#024b82" }}>Tablas de retención documental - TRD</h3>
        </Col>
      </Row>
      <Row>
        <DocumentRetention />
      </Row>
    </Container>
  );
}
